import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "react-apollo";

import { Field, Control, Label } from "rbx";

import ReactSelect from "react-select";
import { ALL_EMPLOYEES_QUERY } from "../../../graphql/Employees/Employees.graphql";

import "./CustomDriverSelect.scss";

function DriverSelect({
  value,
  label,
  size,
  name = "DriverRecIdRef",
  onChange = () => {},
  disabled,
  placeholder = "Driver",
  startDate
}) {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);

  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const {
          data: { Employees = [] }
        } = await client.query({
          query: ALL_EMPLOYEES_QUERY,
          variables: {
            where: {
              DriverFlag: true,
              Active: true,
              NextCertExp: true,
              startDate
            },
            orderByMulti: ["LastName_ASC", "FirstName_ASC"]
          }
        });
        const result = Employees.map(({ RecId, FirstName, LastName }) => ({
          value: RecId,
          label: `${LastName}, ${FirstName}`
        }));

        setOptions(result);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [client, startDate]);

  const handleChange = option => {
    console.log(option);
    onChange(name, option.value);
  };

  const selected = value
    ? options.find(opt => opt.value === parseInt(value))
    : undefined;

  return (
    <div className="custom-driver-select-container">
      <Field>
        <Label size={size}>{label}</Label>
        <Control size={size}>
          <ReactSelect
            className="custom-driver-select"
            isDisabled={disabled}
            isLoading={loading}
            menuPosition="fixed"
            name={name}
            options={options}
            placeholder={placeholder}
            value={selected}
            onChange={handleChange}
          />
        </Control>
      </Field>
    </div>
  );
}

DriverSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  startDate: PropTypes.string
};

DriverSelect.defaultProps = {};
export default DriverSelect;
